import { CargoCompanyCargoTaxiContractsItem } from "../../../../../../common/services/cargo-company/cargo-taxi/contracts/cargo-company-cargo-taxi-contracts";
import CargoTaxiContractListingItem from "../types/cargo-taxi-contract-listing-item";

const createListingItem = (
  responseDataItem: CargoCompanyCargoTaxiContractsItem,
): CargoTaxiContractListingItem => {
  return {
    uuid: responseDataItem.id,
    discountPercentLimit: responseDataItem.discountLimit,
    distanceRate: responseDataItem.distanceRate,
    freeStoppingPeriodMinutes: responseDataItem.haltingTimeAfterMinutes,
    stoppingRate: responseDataItem.haltingTimeRate,
    isTollRoadsDuringOrderAllowed: responseDataItem.allowChargeDuringRide,
    isTollRoadsWhileApproachingAllowed:
      responseDataItem.allowChargeWhileApproaching,
    isTollRoadsWhileReturningAllowed:
      responseDataItem.allowChargeWhileReturning,
    isActive: responseDataItem.valid,
    billingModel: responseDataItem.model,
    isOrderPublishingAllowed: responseDataItem.publishingAllowed,
    taxiCorporation: responseDataItem.taxiCorporation.companyName,
    validFrom: new Date(responseDataItem.validSince),
    validTo: new Date(responseDataItem.validTo),
  };
};

const createListingItems = (
  responseDataItems: CargoCompanyCargoTaxiContractsItem[],
): CargoTaxiContractListingItem[] => {
  const result = responseDataItems.map(createListingItem);
  return result;
};

const cargoTaxiContractListingFactory = { createListingItems };

export default cargoTaxiContractListingFactory;
